const translations = {
  "en": {
    "Privacy Policy": "Privacy Policy",
    "Terms of Use": "Terms of Use"
  },
  "zh-tw": {
    "Privacy Policy": "隱私權政策",
    "Terms of Use": "使用條款"
  }
};

export default translations;
